export enum ToolbarComponentEnum {
  FEATURE_INFO = 'FEATURE_INFO',
  SELECT_COORDINATES = 'SELECT_COORDINATES',
  MEASURE = 'MEASURE',
  STREETVIEW = 'STREETVIEW',
  EDIT = 'EDIT',
}
